import {
  DELETE_PROFESSIONAL_LIST,
  DELETE_PROFESSIONAL_LIST_SUCCESS,
  DELETE_PROFESSIONAL_LIST_FAILURE,
} from 'store/deleteProfessional/deleteProfessionalAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const deleteProfessionalListReducer = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_PROFESSIONAL_LIST:
      return { ...state, loading: true };
    case DELETE_PROFESSIONAL_LIST_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case DELETE_PROFESSIONAL_LIST_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default deleteProfessionalListReducer;
